/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Faq_Start_QInputs */

const en_platform_faq_start_q = /** @type {(inputs: Platform_Faq_Start_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long does it take to set up?`)
};

const pl_platform_faq_start_q = /** @type {(inputs: Platform_Faq_Start_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ile zajmuje konfiguracja?`)
};

/**
* | output |
* | --- |
* | "How long does it take to set up?" |
*
* @param {Platform_Faq_Start_QInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_faq_start_q = /** @type {((inputs?: Platform_Faq_Start_QInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Faq_Start_QInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_faq_start_q(inputs)
	return en_platform_faq_start_q(inputs)
});